import { QueryParams } from '../core/enums/queryParams';

export const elegantEnabled = (url: string) => url.includes(`${QueryParams.ElegantOverride}=true`);
